import { CREDIT_TYPE } from "../../util/constants";
import { dropdownSubtypes, inputMappings } from "../../util/enums";

export const formSections = [
  {
    id: "form",
    questions: [
      {
        title: "Graduation Level",
        id: "graduation-information-level",
        required: true,
        type: inputMappings.dropDown,
        summary: "If you are uncertain of your academic level, please contact your graduate program coordinator.",
        subtype: dropdownSubtypes.graduationLevel,
        branch: "graduation-information-plan",
        dataField: "gradLevel"
      },
      {
        title: "Graduation Plan",
        id: "graduation-information-plan",
        required: true,
        type: inputMappings.dropDown,
        subtype: dropdownSubtypes.graduatePrograms,
        filter: [
          {
            field: "graduation-information-level",
            match: "gradLevel",
            operation: "includes"
          }
        ],
        dataField: "academicPlan",
        results: [
          {
            label: "Graduation Degree",
            field: "degree",
            dataField: "gradDegree"
          }
        ],
        dependencyHelperText: "Graduation Level must be selected before choosing a Graduation Plan",
        dependencies: ["graduation-information-level"]
      },
      {
        title: "Credit Type",
        id: "credit-type",
        dataField: "creditType",
        type: inputMappings.dropDown,
        summary: "Select Graduate Non-Degree if requesting OSU non-degree credit (up to 10 credit hours) be applied to your current program. Select Outside Institution if requesting external (non-OSU) credits be applied to your current program. Please refer to the Graduate School Handbook for limitations.",
        subtype: dropdownSubtypes.creditType,
        required: true,
        onOptionSelected: (event) => {
          if([CREDIT_TYPE.GRADNONDEGREE, CREDIT_TYPE.SENIORPETITION].includes(event?.value)) {
            const value = "Ohio State University";
            const elements = document.getElementsByName("courses-ig-institution");
            for(const element of elements) {
              // set Transfer Course Institution to Ohio State
              if(element?.value !== value) {
                const setValue = Object.getOwnPropertyDescriptor(element.__proto__, 'value').set;
                const inputEvent = new Event('input', { bubbles: true });
                setValue.call(element, value);
                element.dispatchEvent(inputEvent);
              }
            }
          }
        }
      },
      {
        id: "transfer-courses",
        title: "Transfer Courses",
        summary: "If this request is for multiple courses of the same credit type, use the add button to add more courses to the form. If this request is to Transfer a Master’s Degree you do not need to list each course, just the institution from which the degree was granted.",
        type: inputMappings.inputGroup,
        numberOfResponsesMinimum: 1,
        numberOfResponsesMaximum: 20,
        dataField: "courses",
        required: true,
        questions: [
          {
            id: "courses-ig-institution",
            type: inputMappings.textInput,
            title: "Institution",
            dataField: "institution",
            summary: null,
            required: false,
            gridProps: {
              xs: 6,
              lg: 4,
              md: 6
            }
          },
          {
            id: "courses-ig-title",
            type: inputMappings.textInput,
            title: "Course Title",
            dataField: "courseTitle",
            summary: null,
            required: false,
            gridProps: {
              xs: 6,
              md: 6,
              lg: 4
            }
          },
          {
            id: "courses-ig-number",
            type: inputMappings.textInput,
            title: "Course Number",
            dataField: "courseNumber",
            summary: null,
            required: false,
            gridProps: {
              xs: 6,
              md: 4,
              lg: 2
            }
          },
          {
            id: "courses-ig-credit-hours",
            type: inputMappings.numberInput,
            title: "Credit Hours",
            dataField: "creditHours",
            summary: null,
            required: false,
            gridProps: {
              xs: 6,
              md: 4,
              lg: 2
            },
            inputProps: {
              min: 0
            }
          }
        ],
        options: {
          viewAsTable: true,
        }
      },
      {
        id: "advisor",
        type: inputMappings.dropDown,
        title: "Advisor",
        subtype: dropdownSubtypes.advisor,
        summary: null,
        required: false,
        numberOfResponsesMinimum: 1,
        numberOfResponsesMaximum: 1,
        dataField: "advisor",
        dependencies: ["graduation-information-plan"],
        dependencyHelperText: "Graduation Plan must be selected before choosing an Advisor",
        choices: []
      }
    ]
  }
];

export const additionalFilters = [
  {
    id: "credit-type",
    title: "Credit Type",
    required: false,
    type: inputMappings.dropDown,
    subtype: dropdownSubtypes.creditType
  }
];